// ABOUTME: Edits reusable WhatsApp application flow models.
// ABOUTME: Loads a company model and publishes immutable template versions.
import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { useTranslation } from "react-i18next";
import WhatsappApplicationPanel from "Pages/Job/JobView/JobShare/WhatsappApplication/WhatsappApplicationPanel";

const WhatsappApplicationFlowModelEdit = (props: any) => {
    const [t, i18n, readyTranslation] = useTranslation("JOBSHAREMODULE", {
        useSuspense: false
    });

    if (!readyTranslation) {
        return <Page><Loading /></Page>;
    }

    return (
        <Page
            featureName={t("whatsappApplicationModelEditTitle")}
            featureMainDescription={t("whatsappApplicationModelDescription")}
            maxWidth="lg"
        >
            <WhatsappApplicationPanel
                t={t}
                configurationScope="model"
                modelId={props.modelId}
                jobTitle={t("whatsappApplicationModelDefaultName")}
            />
        </Page>
    );
};

export default WhatsappApplicationFlowModelEdit;
